import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import Link from '@components/primitives/Link'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import kebabCase from 'lodash/kebabCase'

export default function AuthorBox({
  aboutPath,
  authorType,
  className = 'my-10 lg:my-20',
  credential,
  description,
  firstPublished,
  imageSource,
  lastReviewed,
  name,
}: {
  aboutPath: string
  authorType: string
  className?: string
  credential: string
  description: JSX.Element
  firstPublished: string
  imageSource: string
  lastReviewed: string
  name: string
}) {
  return (
    <section
      aria-label='about-the-author'
      className={className}
      id={`about-the-author-${kebabCase(name)}`}
    >
      <Text
        className='mb-0 mt-4 text-neutral900 lg:mb-4'
        element={'h3'}
        styleName='h3'
        value={authorType ? `About The ${authorType}` : 'About The Author'}
      />
      <div
        className={classMerge(
          'inline-block',
          'h-auto',
          'w-full',
          'border',
          'border-neutral200',
          'lg:rounded-2xl',
          'rounded-xl',
          'mb-4',
          'lg:p-6',
          'p-4',
          'bg-neutral50',
        )}
      >
        <div className='flex flex-row items-center justify-start gap-4'>
          <CloudflareImage
            alt={`${name} preview`}
            className='mt-4 scale-75 rounded-full lg:mt-0 lg:scale-100'
            height={80}
            imageId={imageSource}
            width={80}
          />
          <div className={'flex flex-col'}>
            <Link href={absoluteUrl(DynamicRoutes.aboutAuthor(aboutPath))}>
              <Text
                styleName='p-small-strong'
                value={
                  <p>
                    {name} - {credential}
                  </p>
                }
              />
            </Link>
            <div className='flex-col lg:flex lg:space-y-0'>
              <Text
                className='text-neutral600'
                styleName='p-small'
                value={<p>First Published: {firstPublished}</p>}
              />
              <Text
                className='text-neutral600'
                styleName='p-small'
                value={<p>Last Reviewed: {lastReviewed}</p>}
              />
            </div>
          </div>
        </div>
        <Text
          className='pt-2 text-neutral600'
          styleName='p-small'
          value={description}
        />
      </div>
    </section>
  )
}
